import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { formatFromSearchType } from '../../../../util/formatUtil';
import { SearchAsk, SearchInputText, SearchImageLeft, SearchImageRight } from '../../../tools/common/PageLayout.styles';

const DTSearchInput = (props) => {
  const {
    onSearchSubmit,
    placeholder = 'Ask a question',
    messageImg = true,
    searchType,
    defaultValue,
    searchValue,
  } = props;

  const [focused, setFocused] = useState(false);
  const [value, setValue] = useState(searchValue || defaultValue || '');

  useEffect(() => {
    setValue(searchValue || defaultValue || '');
  }, [searchValue, defaultValue]);

  const displayValue = value === defaultValue ? formatFromSearchType(searchType, value) : value;

  const handleFocus = () => setFocused(true);
  const handleBlur = () => setFocused(false);

  const handleInputChange = (event) => {
    setValue(event.target.value);
  };

  const handlerKeyDown = (event) => {
    if (event.key === 'Enter') {
      onSearchSubmit(value);
    }
  };

  return (
    <SearchAsk focused={focused}>
      <SearchImageLeft hide={!messageImg}>
        {messageImg ? <img src="/images/message-box.svg" alt="message-box" /> : null}
      </SearchImageLeft>
      <SearchInputText
        value={displayValue}
        key={searchType}
        onFocus={handleFocus}
        onBlur={handleBlur}
        onChange={handleInputChange}
        placeholder={placeholder}
        onKeyDown={handlerKeyDown}
      />
      <SearchImageRight onClick={() => onSearchSubmit(value)}>
        <img style={{ width: '15px' }} src="/images/magnifying-glass.svg" alt="magnifying-glass" />
      </SearchImageRight>
    </SearchAsk>
  );
};

DTSearchInput.propTypes = {
  onSearchSubmit: PropTypes.func.isRequired,
  searchValue: PropTypes.string,
  defaultValue: PropTypes.string,
  searchType: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
};

export default DTSearchInput;
